'use strict';

import jQuery from 'jquery';
import Core from './../Core/Core';

var PostPage = (function($) {
  return function PostPage(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    privateNS.init = function init() {

      // Give this module a name for state management
      privateNS.name = 'post';

      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Create a reference to the comments section
      privateNS.$comments = privateNS.$container.find('.post-comments');

      // Attach event handlers
      privateNS.attachHandlers();

      return publicNS;
    };

    privateNS.toggleComments = function toggleComments() {
      privateNS.$comments.find('.fa-plus, .fa-minus, .post-comments-feed').toggleClass('hide');
    };

    privateNS.attachHandlers = function attachHandlers() {

      // Social (Facebook, Twitter and Email)
      privateNS.$container.on('click', '.social-share',
          Core.utils.onSocialShare
      );

      privateNS.$comments.on(
        'click',
        function(e) {
          e.preventDefault();
          privateNS.toggleComments();
        }
      );
    };

    return privateNS.init();
  };
})(jQuery);

export default new PostPage({container: '#post-container'});
